import Vue from 'vue'

import {
  url
} from '@/api/config'

function get(path) {
  return Vue.http.get(url + path, {});
}

function post(path, myparams) {
  return Vue.http.post(url + path, myparams, {
    headers: {
      'Content-Type': 'application/json'
    },
  });
}

function error(response) {
  return "error";
}


function myimport(file) {
  Vue.component(file, '@/components/' + file + '.vue')
  return require('@/components/' + file + '.vue').default;
}

function myAddAlertError(that, reason) {
  that.$alert(reason, '添加失败', {
    confirmButtonText: '确定',
    showClose: false,
  });
}

function filterAsyncRouter(asyncRouterMap) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      route.component = myimport(route.component)
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
  return accessedRouters
}

export {
  get,
  post,
  error,
  myAddAlertError,
  filterAsyncRouter
}



// WEBPACK FOOTER //
// ./src/api/common.js